import React from "react";
import { Box, Button, SwipeableDrawer, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import AnalyticsService from "../../Services/AnalyticsService";
import AndroidService from "../../Services/AndroidService";

const useStyles = makeStyles({
  puller: {
    width: 50,
    height: 6,
    position: "absolute",
    top: 10,
    left: "calc(50% - 25px)",
    borderRadius: 3,
    backgroundColor: "#ddd",
  },
});
export default function ActionConfirmationDrawer(props) {
  const classes = useStyles();

  const onCloseClicked = () => {
    const closeEventData = {
      page: "Field Agent Return Order Details",
      type: "Close Clicked Approve Bottom Sheet",
    };
    AnalyticsService.pushEvent("Button Clicked", closeEventData);
    props.setShowConfirmation(false);
  };

  const onApproveConfirmedClicked = () => {
    const approveEventData = {
      page: "Field Agent Return Order Details",
      type: "Confirm Clicked Approve Bottom Sheet",
    };
    AnalyticsService.pushEvent("Button Clicked", approveEventData);
    props.handleAction();
  };

  return (
    <SwipeableDrawer
      anchor={`bottom`}
      open={props.showConfirmation}
      disableDiscovery={true}
      disableSwipeToOpen={true}
      onOpen={() => AndroidService.unsetPullToRefresh()}
      onClose={() => {
        AndroidService.setPullToRefresh();
        props.setShowConfirmation(false);
      }}
      sx={{
        "& .MuiDrawer-paper": {
          borderTopLeftRadius: 30,
          borderTopRightRadius: 30,
        },
        maxWidth: "600px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className={classes.puller}></div>
        <img
          src="/icons/cross.svg"
          style={{
            alignSelf: "end",
            margin: "20px 20px 10px 20px",
          }}
          onClick={() => {
            onCloseClicked();
          }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <img style={{ width: "50px", height: "50px" }} src={props.svg} />
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "black",
              margin: "10px",
            }}
          >
            {props.confirmationMessage}
          </Typography>
          <Button
            fullWidth
            sx={{
              background: "#00733E",
              height: "50px",
              borderRadius: "0",
              color: "white",
            }}
            onClick={() => onApproveConfirmedClicked()}
          >
            {props.actionText}
          </Button>
        </Box>
      </Box>
    </SwipeableDrawer>
  );
}
